interface AppConfig {
  baseUrl: string;
  locationPrefix: string;
  apiHost: string;
  axiosWithCredentials: boolean;
  isHotSwapMode: boolean;
}

const getConfig = (): AppConfig => {
  const isHotSwapMode = process.env.NODE_ENV === 'development';

  const baseUrl = (isHotSwapMode
    ? process.env.REACT_APP_HOT_SWAP_BASE_URL
    : process.env.REACT_APP_PROD_BASE_URL) || '/';

  const locationPrefix = (isHotSwapMode
    ? process.env.REACT_APP_HOT_SWAP_LOCATION_PREFIX
    : process.env.REACT_APP_PROD_LOCATION_PREFIX) || '';

  const apiHost = (isHotSwapMode
    ? process.env.REACT_APP_HOT_SWAP_API_HOST
    : process.env.REACT_APP_PROD_API_HOST) || '';

  const axiosWithCredentials = isHotSwapMode
    ? process.env.REACT_APP_HOT_SWAP_AXIOS_WITH_CREDENTIALS === 'true'
    : process.env.REACT_APP_PROD_AXIOS_WITH_CREDENTIALS === 'true';

  if (isHotSwapMode) {
    console.log('[index.ts] config: ', {
      baseUrl,
      locationPrefix,
      apiHost,
      axiosWithCredentials,
      isHotSwapMode,
    })
  }

  return {
    baseUrl,
    locationPrefix,
    apiHost,
    axiosWithCredentials,
    isHotSwapMode,
  };
};

export const config = getConfig();

export const getFullApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${config.apiHost}${normalizedPath}`;
};

export const getFullLocationUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') || path.startsWith('#') ? path : `/${path}`;
  const locationPath = config.locationPrefix + normalizedPath;
  return `${config.baseUrl}${locationPath.replace(/^\//, '')}`;
};
